import Vue from "vue";
import _ from "lodash";
import moment from 'moment';

import mixin from '@general/lib/mixin';
import auth from '@general/lib/auth'

import notificationsModule from '@notifications/module/store/type'
import discoverModule from "@discover/module/store/type";
import chatModule from "@chat/module/store/type";
import eventsModule from "@events/module/store/type";
import clubsModule from "@clubs/module/store/type";
import axios from "axios";

const actions = {
    showHealthAlert(store) {
        let lastAlertDate = localStorage.getItem('lastHealthAlertDate')
        if (
            lastAlertDate === null
            ||
            moment().diff(moment(lastAlertDate), 'hours') > 24
        ) {
            store.commit('setHealthAlert', true)
            localStorage.setItem('lastHealthAlertDate', moment().toISOString())
        }
    },
    async getFavorites(store, infiniteScroll){
        axios.get(`/api/favourites?page=` + store.getters['getFavoritesPage'] + '&limit=20')
            .then((response) => {
                store.state.favourites.push(...response.data);
                store.commit("setFavoritesPage",parseInt(store.getters['getFavoritesPage']) + 1)
                if (response.data.length) {
                    infiniteScroll.loaded()
                }
                if (response.data.length < 20) {
                    infiniteScroll.complete()
                }

            })
    },
    async recoverPasswordStart(store, {email}) {
        let data = {
            email,
            lang: app.lang
        }

        let response = await axios.post('/api/password/email', data)
        if (response.status === 200) {
            return response.data
        }

        return false
    },
    async login(store, {username, password, remember}) {
        let data = {
            grant_type: 'password',
            client_id: 2,
            client_secret: 'nzVQUaVjdmYRVSbPRcosrv9emxvuxaEdQemoNZRi',
            username: username,
            password: password
        }

        let response = await axios.post('/oauth/token', data)
        if (response.status === 200) {
            let data = response.data
            let token = data.access_token

            auth._setAxiosAuthorizationHeader(token)

            let userLoaded = await store.dispatch('loadCurrentUserInfo')
            if (userLoaded) {
                let userId = store.state.profile.id
                if(!_.isUndefined(userId)) {
                    auth._rememberUser(token, userId, remember)

                    console.log('[Poll] User logged in. Profile loaded. Start polling.')
                    // store.dispatch('enableUserOnlineStatusPolling')
                    return true
                }
            }
        }

        return false
    },
    closeAdminPopUp(store,payload){
        axios.post('/api/markPopUpShown', {id: payload.popup.id})
        store.commit('closeAdminPopUp',payload.popup)
        store.dispatch('showAdminPopUp', payload.page)
    },
    showAdminPopUp(store, page){
        if(store.state.adminPopUps){
            let modal_shown = false;
            $.each(store.state.adminPopUps,function(key, popup){
                if((!popup.pages || popup.pages.includes(page)) && !modal_shown){
                    store.commit('openAdminPopUp',{popup,page})
                    modal_shown = true;
                }
            })
        }
    },

    signalMessagesSeen(store) {
        let newValue = {
            has_new_messages: false
        }
        store.commit('updateUser', newValue)
        axios.post('/api/updateUser', newValue)
    },
    signalClubsSeen(store) {
        let newValue = {
            has_club_notifications: false
        }
        store.commit('updateUser', newValue)
        axios.post('/api/updateUser', newValue)
    },
    signalClubSeen(store, payload) {
        let newValue = {
            has_new_applicants: false
        }
        store.commit(clubsModule.mutations.clubs.update, {
            clubId:   payload.id,
            clubData: newValue
        })
        axios.post(`/api/event/notification/${payload.id}`, newValue)
    },

    updateSidebarVisibility(store, payload){
        store.commit('updateSidebarVisibility', payload)
    },
    showDialog(store, settings){
        if (store.state.dialog.visible === true && settings.visible === true){
            store.dispatch('hideDialog')
        }
        store.commit('updateDialog', {...settings, visible: true })
    },
    hideDialog(store){
        store.commit('updateDialog', {
            mode: 'success',
            visible: false,
            callback: null,
            callbackNegative: null
        })
    },
    goToMyProfile() {
        app.goTo(app.lastProfilePage);
    },
    async shareVideos(store, videosIds) {
        try {
            let response = await axios.post('/api/share-videos', { videosIds })
            let sharingUrl = response.data.sharingUrl

            store.commit('setSharingUrl', sharingUrl);
        } catch (error) {
            console.log(error)
            return
        }
    },
    async checkUserLink(store, data){
        return await axios.post('/api/register/check-handle',{
            handle : data.handle,
            except_type : data.type,
            except_id : data.id
        })
    },
    async inviteBuddies(store, data) {
        try {
            let response = await axios.post('/api/invite-members', data)

            // let sharingUrl = response.data.sharingUrl
            // store.commit('setSharingUrl', sharingUrl);
        } catch (error) {
            console.log(error)
            return
        }
    },
    async getSpotTags(store, data) {
        try {
            let response = await axios.get('/api/spot-tags', {})

            store.commit('setSpotTags', response.data)
        } catch (error) {
            console.log(error)
            return
        }
    },
    async getAvailableEmojies(store, data) {
        try {
            let response = await axios.get('/api/available-emojies', {})

            store.commit('setAvailableEmojies', response.data)
        } catch (error) {
            console.log(error)
            return
        }
    },
    async loadCurrentUserInfo(store, forceReload = false) { //can use argument destructuring here as {commit}
        console.log('loadCurrentUserInfo check state', auth._hasAxiosAuthorizationHeader(), _.isEmpty(store.state.profile.id), store, store.state.profile, forceReload)

        if (
            auth._hasAxiosAuthorizationHeader()
            &&
            (
                _.isEmpty(store.state.profile.id)
                ||
                forceReload
            )
        ) {
            let data = null
            // Send main request
            await axios.get('/api/currentUserInfo')
                .then( (res) => {
                    console.log('currentUserInfo request', res, res.status)
                    data = res.data
                    console.log('currentUserInfo response', data)
                }).catch((error) => {
                    console.error(error)
                    if ((error || error.request) && (error.status === 401 || Math.floor(error.status / 100) === 5)) {
                        app.logout()
                        store.commit('logout')
                        return
                    }
                });
            // IMPORTANT TO BE IMMEDIATELY HERE
            // Check user suspended and deleted status
            if (data.user.status === 'suspended' || !!data.user.deleted_at) {
                app.logout();
                store.commit('logout');
                return
            }

            // Check user deactivated status
            if (data.user.status === 'deactivated') {
                app.goTo('/profile/inactive')
            }

            // check if user language is set in db
            if (!data.user.language && app.lang) {
                data.user.language = app.lang;
                axios.post('/api/updateUser', {language: app.lang})
            }

            // Set app language from user profile
            if (data.user.language !== app.lang) {
                Vue.nextTick(function(){
                    app.setLanguage(data.user.language);
                })
            }

            // if (!data.user.is_guide_modal_shown) {
            //     app.$emit('show-parties-on', true)
            // }
            store.commit('setUser', data.user);
            store.commit('setOnlineFavorites', data.onlineFavorites);

			store.commit('setMyTaps', data.myTaps)
            store.commit('setProfileOptions', data.options)
            store.commit('setProfilePhotos', data.photos)
            store.commit('setProfileVideos', data.videos)
            store.commit('setMyClubs', data.myClubs)
            store.commit('setAdminPopUps', data.adminPopUps)

            store.commit('setInvitationsToBang', data.invitationsToBang)
            store.commit('setInvitationsToClub', data.invitationsToClub)
            store.commit('setFavoritesCount', data.favoritesCount)
            store.commit('setBlockedCount', data.blockedCount)
            store.commit('setBlockedUsersIds', data.blockedUsersIds)
            store.commit('setUserIsPro', data.user.isPro)
            store.commit('setLatestWidget', data.latestWidget)
            store.commit('setDiscreetMode', data.user.discreet_mode)
            store.commit('setMeetNowUsers', data.meetNowUsers)

            store.commit(chatModule.mutations.general.setUnreadConversationsIds, data.user.unreadConversationsIds)

            store.dispatch(eventsModule.actions.membership.set, data.membershipRequests)
            store.dispatch(eventsModule.actions.membership.setMy, data.activeMemberships)

            store.dispatch(clubsModule.actions.membership.set, data.membershipClubsRequests)

            //store.dispatch(clubsModule.actions.membership.setMy, data.activeClubsMemberships)

            return true
        }else{
            store.commit('setProfileOptions', {
                    "heights": {
                        "150": "150cm (4'11”)",
                        "151": "151cm (4'11”)",
                        "152": "152cm (5'0”)",
                        "153": "153cm (5'0”)",
                        "154": "154cm (5'1”)",
                        "155": "155cm (5'1”)",
                        "156": "156cm (5'1”)",
                        "157": "157cm (5'2”)",
                        "158": "158cm (5'2”)",
                        "159": "159cm (5'3”)",
                        "160": "160cm (5'3”)",
                        "161": "161cm (5'3”)",
                        "162": "162cm (5'4”)",
                        "163": "163cm (5'4”)",
                        "164": "164cm (5'5”)",
                        "165": "165cm (5'5”)",
                        "166": "166cm (5'5”)",
                        "167": "167cm (5'6”)",
                        "168": "168cm (5'6”)",
                        "169": "169cm (5'7”)",
                        "170": "170cm (5'7”)",
                        "171": "171cm (5'7”)",
                        "172": "172cm (5'8”)",
                        "173": "173cm (5'8”)",
                        "174": "174cm (5'9”)",
                        "175": "175cm (5'9”)",
                        "176": "176cm (5'9”)",
                        "177": "177cm (5'10”)",
                        "178": "178cm (5'10”)",
                        "179": "179cm (5'10”)",
                        "180": "180cm (5'11”)",
                        "181": "181cm (5'11”)",
                        "182": "182cm (6'0”)",
                        "183": "183cm (6'0”)",
                        "184": "184cm (6'0”)",
                        "185": "185cm (6'1”)",
                        "186": "186cm (6'1”)",
                        "187": "187cm (6'2”)",
                        "188": "188cm (6'2”)",
                        "189": "189cm (6'2”)",
                        "190": "190cm (6'3”)",
                        "191": "191cm (6'3”)",
                        "192": "192cm (6'4”)",
                        "193": "193cm (6'4”)",
                        "194": "194cm (6'4”)",
                        "195": "195cm (6'5”)",
                        "196": "196cm (6'5”)",
                        "197": "197cm (6'6”)",
                        "198": "198cm (6'6”)",
                        "199": "199cm (6'6”)",
                        "200": "200cm (6'7”)",
                        "201": "201cm (6'7”)",
                        "202": "202cm (6'8”)",
                        "203": "203cm (6'8”)",
                        "204": "204cm (6'8”)",
                        "205": "205cm (6'9”)",
                        "206": "206cm (6'9”)",
                        "207": "207cm (6'9”)",
                        "208": "208cm (6'10”)",
                        "209": "209cm (6'10”)",
                        "210": "210cm (6'11”)",
                        "211": "211cm (6'11”)",
                        "212": "212cm (6'11”)"
                    },
                    "weights": {
                        "45": "45kg (99 lbs)",
                        "46": "46kg (101 lbs)",
                        "47": "47kg (104 lbs)",
                        "48": "48kg (106 lbs)",
                        "49": "49kg (108 lbs)",
                        "50": "50kg (110 lbs)",
                        "51": "51kg (112 lbs)",
                        "52": "52kg (115 lbs)",
                        "53": "53kg (117 lbs)",
                        "54": "54kg (119 lbs)",
                        "55": "55kg (121 lbs)",
                        "56": "56kg (123 lbs)",
                        "57": "57kg (126 lbs)",
                        "58": "58kg (128 lbs)",
                        "59": "59kg (130 lbs)",
                        "60": "60kg (132 lbs)",
                        "61": "61kg (134 lbs)",
                        "62": "62kg (137 lbs)",
                        "63": "63kg (139 lbs)",
                        "64": "64kg (141 lbs)",
                        "65": "65kg (143 lbs)",
                        "66": "66kg (146 lbs)",
                        "67": "67kg (148 lbs)",
                        "68": "68kg (150 lbs)",
                        "69": "69kg (152 lbs)",
                        "70": "70kg (154 lbs)",
                        "71": "71kg (157 lbs)",
                        "72": "72kg (159 lbs)",
                        "73": "73kg (161 lbs)",
                        "74": "74kg (163 lbs)",
                        "75": "75kg (165 lbs)",
                        "76": "76kg (168 lbs)",
                        "77": "77kg (170 lbs)",
                        "78": "78kg (172 lbs)",
                        "79": "79kg (174 lbs)",
                        "80": "80kg (176 lbs)",
                        "81": "81kg (179 lbs)",
                        "82": "82kg (181 lbs)",
                        "83": "83kg (183 lbs)",
                        "84": "84kg (185 lbs)",
                        "85": "85kg (187 lbs)",
                        "86": "86kg (190 lbs)",
                        "87": "87kg (192 lbs)",
                        "88": "88kg (194 lbs)",
                        "89": "89kg (196 lbs)",
                        "90": "90kg (198 lbs)",
                        "91": "91kg (201 lbs)",
                        "92": "92kg (203 lbs)",
                        "93": "93kg (205 lbs)",
                        "94": "94kg (207 lbs)",
                        "95": "95kg (209 lbs)",
                        "96": "96kg (212 lbs)",
                        "97": "97kg (214 lbs)",
                        "98": "98kg (216 lbs)",
                        "99": "99kg (218 lbs)",
                        "100": "100kg (220 lbs)",
                        "101": "101kg (223 lbs)",
                        "102": "102kg (225 lbs)",
                        "103": "103kg (227 lbs)",
                        "104": "104kg (229 lbs)",
                        "105": "105kg (231 lbs)",
                        "106": "106kg (234 lbs)",
                        "107": "107kg (236 lbs)",
                        "108": "108kg (238 lbs)",
                        "109": "109kg (240 lbs)",
                        "110": "110kg (243 lbs)",
                        "111": "111kg (245 lbs)",
                        "112": "112kg (247 lbs)",
                        "113": "113kg (249 lbs)",
                        "114": "114kg (251 lbs)",
                        "115": "115kg (254 lbs)",
                        "116": "116kg (256 lbs)",
                        "117": "117kg (258 lbs)",
                        "118": "118kg (260 lbs)",
                        "119": "119kg (262 lbs)",
                        "120": "120kg (265 lbs)",
                        "121": "121kg (267 lbs)",
                        "122": "122kg (269 lbs)",
                        "123": "123kg (271 lbs)",
                        "124": "124kg (273 lbs)",
                        "125": "125kg (276 lbs)"
                    },
                    "bodyTypes": {
                        "slim": "slim",
                        "average": "average",
                        "athletic": "athletic",
                        "muscular": "muscular",
                        "stocky": "stocky"
                    },
                    "penisSizes": {
                        "S": "S",
                        "M": "M",
                        "L": "L",
                        "XL": "XL",
                        "XXL": "XXL"
                    },
                    "positionTypes": {
                        "top": "top",
                        "more_top": "more_top",
                        "versatile": "versatile",
                        "more_bottom": "more_bottom",
                        "bottom": "bottom"
                    },
                    "hivTypes": {
                        "positive": "positive",
                        "negative": "negative",
                        "undetectable": "undetectable",
                        "prep": "prep",
                        "unknown": "unknown"
                    },
                    "drugsTypes": {
                        "yes": "yes",
                        "no": "no",
                        "socially": "socially"
                    },
                    "defaultPhotos": {
                        "photo": null,
                        "photo_orig": "/assets/img/default_orig.jpg",
                        "photo_small": "/assets/img/default_180x180.jpg"
                    }
            })
        }

        return false
    },
    clearBlockedUsers(store) {
        store.commit('clearBlockedUsers')
    },
    async getBlockedUsers(store, { page, limit }) {
        try {
            let data = null;
            let response = await axios.post('/api/blockedUsers', { page, limit })

            if (response.status === 200) {
                data = response.data;
            } else if (error.status === 401){
                app.logout()
                store.commit('logout')
                return
            } else {
                return
            }

            store.commit('setBlockedUsers', data);

            return data;

        } catch (error) {
            console.log(error)
            return
        }
    },
    async unblockUser(store, { blockedUserId }) {
        try {
            let response = await axios.post('/api/unblockUser', { blockedUserId })

            if (response.status === 200) {
                store.commit('updateBlockedUsers', blockedUserId)
            } else if (error.status === 401) {
                app.logout()
                store.commit('logout')
                return
            } else {
                return
            }

        }  catch (error) {
            console.log(error)
            return
        }
    },
    async getHandlesList(store,  {except,handle,limit,page} ) {
        console.log('getHandlesList' , handle);
        try {
            let response = await axios.get('/api/handlesList', { params: {except:except,handle : handle, limit:limit, page: page} })

            if (response.status === 200) {
                return response.data;
            } else {
                return
            }

        }  catch (error) {
            console.log(error)
            return
        }
    },
    // Poll func, every REFRESH_LAST_ACTIVE_SECONDS
    async updateUserStatus(store) {
        let ids = store.getters[chatModule.getters.conversations.userIds]
        let notificationsUserIds = store.getters[notificationsModule.getters.notifications.wave].map(e => e.user_from.id)
        ids.push(...notificationsUserIds)

        let response = await axios.post('/api/getUserStatus', { ids })
        if (response.status === 200) {
            let data = response.data

            // Update user
            if (!!data.user) {
                // Check user suspended and deleted status
                if (
                    data.user.status === 'suspended'
                    ||
                    !!data.user.deleted_at
                ) {
                    app.logout()
                    store.commit('logout')
                    return
                }
                store.commit('setUser', data.user)
            }

            //update meet_now_users
            if(!!data.meet_now_users){
                store.commit('setMeetNowUsers',data.meet_now_users)
                if(data.meet_now_users && data.meet_now_users.length){
                    $.each(data.meet_now_users,function (key,val){
                        if(auth.getUserId() !== val.id){
                            store.commit(discoverModule.mutations.users.update,{userId : val.id, fields:{meet_now:val.meet_now}})
                        }
                    })
                }
            }

            // Update favourites status
            if (!!data.onlineFavorites) {
                store.commit('setOnlineFavorites', data.onlineFavorites);
            }

            // Update user entries
            if (!!data.freshUsers) {
                data.freshUsers.forEach((user) => {
                    let userId = user.id
                    if (
                        user.status === 'suspended'
                        ||
                        !!user.deleted_at
                    ) {
                        store.dispatch(notificationsModule.actions.remove, { userId })
                        return
                    }

                    store.commit(notificationsModule.mutations.update, {
                        userId,
                        fields: user
                    })

                    store.commit(chatModule.mutations.conversations.update, {
                        tracker: 'updateUserStatus',
                        userId,
                        interlocutor: user
                    })
                })
            }
        }
    },

    async updateDiscoverUserStatus(store) {
        let ids = store.getters[discoverModule.getters.usersAroundInvalidated]
        if (!ids.length) {
            // No invalidated visible users. Abort.
            return
        }

        let response = await axios.post('/api/getUserStatus', { ids })
        if (response.status === 200) {
            let data = response.data

            // Update user entries
            data.freshUsers.forEach((user) => {
                let userId = user.id
                if (
                    user.status === 'suspended'
                    ||
                    !!user.deleted_at
                ) {
                    store.dispatch(discoverModule.actions.users.remove, { userId })
                    return
                }

                store.commit(discoverModule.mutations.users.update, {
                    userId,
                    fields: {...user, loaded: moment() }
                })
            })
        }
    },

    // Poll func, every REFRESH_LAST_ACTIVE_SECONDS
    invalidateDiscoverLists(store) {
        let listLifeTime = window.REFRESH_USERS_AROUND_INTERVAL_SECONDS
        let usersListAge = moment().diff(app.lastUsersAroundRefresh, 'seconds', true)
        let eventListAge = moment().diff(app.lastEventsAroundRefresh, 'seconds', true)
        let debugInfo = {listLifeTime, usersListAge, eventListAge}

        console.log('[Poll] Trying to invalidate discover lists', debugInfo)

        if (usersListAge > listLifeTime) {
            // Invalidate users list
            store.dispatch(discoverModule.actions.users.setRefreshQueued, true)
            console.log('[Poll] Discover users list invalidated', debugInfo)
        }

        if (eventListAge > listLifeTime) {
            // Invalidate events list
            console.log('[Poll] Discover events list invalidated', debugInfo)
        }
    },

    launchPollIteration(store){
        // Update user status and all loaded users
        store.dispatch('updateUserStatus')

        // Users refresh will be queued if location changed
        store.dispatch('checkLocationChange')

        // Users refresh will be queued if discover list was invalidated
        // Events refresh will be queued if event list was invalidated
        store.dispatch('invalidateDiscoverLists')

        // Discover refresh will trigger only:
        // - If list was invalidated
        // - If location changed
        // DO NOT UNCOMMENT IT !!! DISCOVER SHOULD NOT BE AUTOMATICALLY UPDATED....
        // console.log('[Poll] Reset discover')
        // app.$emit('reload-discover')
    },

    // Enable poll
    enableUserOnlineStatusPolling(store) {
        if (auth.isAuthenticated()) {
            let intervalSeconds = window.REFRESH_LAST_ACTIVE_SECONDS
            console.log(`[Poll] Enabled, every ${intervalSeconds} sec.`)

            window.updateUserStatusInterval = setInterval(() => {
                console.log(`[Poll] Iteration started...`)
                store.dispatch('launchPollIteration')
            }, intervalSeconds * 1000)

            // Initial iteration, in 1 sec for loading
            setTimeout(function (){
                //must be started after mounting/creating/activated current vue component
                store.dispatch('launchPollIteration')
            },1000)

            // Soft reload main lists
            store.dispatch('softReloadCachedLists')
        }
    },

    softReloadCachedLists(){
        if (!window.LAST_UPDATE) {
            window.LAST_UPDATE = moment()
        }

        // Mobile devices do not receive any notifications after ~1 min (lock state)
        // So we need to fire "soft reload" event. All main list will be invalidated.
        if (
            app.isMobile
            &&
            moment().diff(window.LAST_UPDATE, 'seconds', true) >= 5
        ) {
            console.log('[Poll] Reloading conversations, messages and notifications')

            app.$emit('invalidate-conversations')
            app.$emit('invalidate-messages')

            app.$emit('invalidate-notifications')
            app.$emit('invalidate-visitors')
            app.$emit('invalidate-visited')

            window.LAST_UPDATE = moment()
        } else {
            console.log('[Poll] Lists are still valid')
        }
    },

    // Disable polling
    disableUserOnlineStatusPolling() {
        clearInterval(window.updateUserStatusInterval)
        console.log(`[Poll] Disabled`)
    },

    async checkLocationChange({ state, dispatch, commit }){
        let updateFields = null;
        let lat, lng;
        let needToRefreshDiscover = false;

        if (state.profile.location_type === 'automatic') {
            commit('setLocationUpdating', true)
            try {
                ({lat, lng} = await mixin.methods.getCurrentPosition())
                if (lat && lng) {
                    let distance = mixin.methods.calculateDistanceBetween(lat, lng, state.profile.lat, state.profile.lng, 'm')

                    // Checking distance threshold for address
                    if (distance > window.REFRESH_ADDRESS_FOR_LAT_LNG_CHANGE_METERS) {
                        console.log('[Geo] Location changed. Updating user\'s profile.', {
                            current: distance,
                            limit: window.REFRESH_ADDRESS_FOR_LAT_LNG_CHANGE_METERS
                        })
                        try {
                            let address = await mixin.methods.getAddressForLatLng(lat, lng, true)
                            updateFields = {
                                lat,
                                lng,
                                address: address.formattedAddress,
                                locality: address.locality,
                                state: address.state,
                                country: address.country,
                                country_code: address.country_code,
                                address_lat: lat,
                                address_lng: lng
                            }

                            console.log('GPS profile');
                            console.log(state.profile);

                            if (state.profile.lat !== lat || state.profile.lng !== lng) {
                                console.log('needToRefreshDiscover set to true');
                                needToRefreshDiscover = true;
                            } else {
                                console.log('needToRefreshDiscover set to false');
                            }
                        } catch (e) {
                            console.log('[Geo] Location error.', e)
                        }
                    } else {
                        console.log('[Geo] Location didn\'t changed. User profile won`t be updated.')
                    }

                    // Checking distance threshold for users around list
                    // if (distance > window.DISTANCE_METERS_DIFFERENCE_RELOAD_USERS_AROUND) {
                    //     console.log(`[Geo] Location changed. Updating users around.`, {
                    //         current: distance,
                    //         limit: window.DISTANCE_METERS_DIFFERENCE_RELOAD_USERS_AROUND
                    //     })
                    //
                    //     // Queue refresh
                    //     dispatch(discoverModule.actions.users.reload, true)
                    // }
                }
            } catch (e) {
                updateFields = {
                    location_type: 'manual'
                }

                dispatch('showDialog', {
                    mode: 'confirm',
                    message: app.trans('fail_load_location'),
                    callback: () => { mixin.methods.goTo('/profile/location') }
                })

                console.log('[Geo] Geolocation detection mode set to "manual" because of error', { e })
            }

            if (updateFields != null) {
                commit('updateUser', updateFields)
                axios.post('/api/updateUser', updateFields)
            }

            commit('setLocationUpdating', false)
        } else {
            console.log('[Geo] Location wasn`t checked because it`s in manual mode')
        }

        if (needToRefreshDiscover) {
            console.log('Reload discover')
            dispatch(discoverModule.actions.users.reload);
            app.$emit('reload-events')
        }
    },

    async forceUpdateLocation({ state, dispatch, commit }){
        let updateFields = null;
        let lat, lng;
        let needToRefreshDiscover = false;

        commit('setLocationUpdating', true)
        try {
            ({lat, lng} = await mixin.methods.getCurrentPosition())

            if (lat && lng) {
                try {
                    let address = await mixin.methods.getAddressForLatLng(lat, lng, true)
                    updateFields = {
                        lat,
                        lng,
                        address: address.formattedAddress,
                        locality: address.locality,
                        state: address.state,
                        country: address.country,
                        country_code: address.country_code,
                        address_lat: lat,
                        address_lng: lng
                    }

                    console.log('GPS profile');
                    console.log(state.profile);

                    if (state.profile.lat !== lat || state.profile.lng !== lng) {
                        console.log('needToRefreshDiscover set to true');
                        needToRefreshDiscover = true;
                    } else {
                        console.log('needToRefreshDiscover set to false');
                    }
                } catch (e) {
                    console.log('[Geo] Location error.', e)
                }

                // Checking distance threshold for users around list
                // let distance = mixin.methods.calculateDistanceBetween(lat, lng, state.profile.lat, state.profile.lng, 'm')
                // if (distance > window.DISTANCE_METERS_DIFFERENCE_RELOAD_USERS_AROUND) {
                //     console.log(`[Geo] Location changed. Updating users around.`, {
                //         current: distance,
                //         limit: window.DISTANCE_METERS_DIFFERENCE_RELOAD_USERS_AROUND
                //     })
                //
                //     // Queue refresh
                //     dispatch(discoverModule.actions.users.setRefreshQueued, true)
                // }
            }
        } catch (e) {
            updateFields = {
                location_type: 'manual'
            }

            dispatch('showDialog', {
                mode: 'error',
                message: app.trans('fail_auto_choose_manual_location')
            })

            console.log('[Geo] Geolocation detection mode set to "manual" because of error', { e })
        }

        if (updateFields != null) {
            commit('updateUser', updateFields)
            axios.post('/api/updateUser', updateFields)
        }
        commit('setLocationUpdating', false)

        if (needToRefreshDiscover) {
            console.log('Reload discover')
            setTimeout(function() {
                dispatch(discoverModule.actions.users.reload);
                app.$emit('reload-events')
            }, 500);
        }
    },

    async loadUserInfo(context, userToken) {
        try {
            let location = localStorage.getItem('location');
            let response = await axios.get(`/api/userInfo/${userToken}?location=${location}`)
            if (response.status === 200) {
                let userId = response.data.id
                if (userId) {
                    Vue.set(context.state.usersInfo, userId, response.data)
                    return response.data
                } else {
                    Vue.set(context.state.usersInfo, userId, null)
                    return null
                }
            }
        } catch (error) {}
        return null
    },

    toggleMeetNow(context){
        context.commit('setModal', {meet_now: true});
    },

    changeMeetNowStatus(context,payload){
        axios.post('/api/meet-now/change',{'action':payload.action})
            .then(({data}) => {
                if (data.success) {
                    //this needed for showing right numbers in timer
                    store.commit('setMeetNowUsers', data.meet_now_users)
                    data.meet_now_users = null;
                    context.commit('updateUser', data)
                    if(payload.callback){
                        payload.callback();
                    }
                } else {

                }
            })
    },

    /**
     * try to switch discreet mode
     */
    trySwitchDiscreetMode(context) {
        if (context.state.userIsPro) {
            axios.post('/api/discreet-mode/change')
                .then(({data}) => {
                    if (data.success) {
                        context.dispatch('loadCurrentUserInfo', true)
                    } else {
                        mixin.methods.showErrorNotification(data.message)
                    }
                })
        } else {
            context.dispatch('requirementsAlertShow', 'mask')
        }
    },

    /**
     * Open profile edit
     */
    openProfileEdit(context) {
        context.commit('openProfileEdit')
    },

    /**
     * Close profile edit
     */
    closeProfileEdit(context) {
        context.commit('closeProfileEdit')
    },

    /**
     * Open Location menu from profile sidebar
     */
    openProfileLocation(context) {
        context.commit('openProfileLocation')
    },

    /**
     * Close Location menu from profile sidebar
     */
    closeProfileLocation(context) {
        context.commit('closeProfileLocation')
    },

    /**
     * Open Photos menu from profile sidebar
     */
    openProfilePhotos(context) {
        context.commit('openProfilePhotos')
    },

    /**
     * Close Photos menu from profile sidebar
     */
    closeProfilePhotos(context) {
        context.commit('closeProfilePhotos')
    },

    /**
     * Open Videos menu from profile sidebar
     */
    openProfileVideos(context) {
        context.commit('openProfileVideos')
    },

    /**
     * Close Videos menu from profile sidebar
     */
    closeProfileVideos(context) {
        context.commit('closeProfileVideos')
    },

    /**
     * Open Settings menu from profile sidebar
     */
    openProfileSettings(context) {
        context.commit('openProfileSettings')
    },

    /**
     * Close Settings menu from profile sidebar
     */
    closeProfileSettings(context) {
        context.commit('closeProfileSettings')
    },

    /**
     * Open Settings menu from profile sidebar
     */
    openProfileShare(context) {
        context.commit('openProfileShare')
    },

    /**
     * Open Settings menu from profile sidebar
     */
    openModeration(context) {
        context.commit('openModeration')
    },

    /**
     * Close Settings menu from profile sidebar
     */
    closeProfileModerations(context) {
        context.commit('closeProfileModerations')
    },

    /**
     * Close Settings menu from profile sidebar
     */
    closeProfileShare(context) {
        context.commit('closeProfileShare')
    },

    /**
     * Open Deactivation menu from profile settings
     */
    openProfileDeactivation(context) {
        context.commit('openProfileDeactivation')
    },

    /**
     * Open openCustomizeSharingLinks menu from profile settings
     */
    openCustomizeSharingLinks(context) {
        context.commit('openCustomizeSharingLinks')
    },

    /**
     * Open Delete All Sharing Links menu from profile settings
     */
    openDeleteAllSharingLinks(context) {
        context.commit('openDeleteAllSharingLinks')
    },

    /**
     * Close Deactivation menu from profile settings
     */
    closeProfileDeactivation(context) {
        context.commit('closeProfileDeactivation')
    },

    /**
     * Close Delete All Sharing Links menu from profile settings
     */
    closeDeleteAllSharingLinks(context) {
        context.commit('closeDeleteAllSharingLinks')
    },

    /**
     * Close CustomizeSharingLinks menu from profile settings
     */
    closeCustomizeSharingLinks(context) {
        context.commit('closeCustomizeSharingLinks')
    },

    /**
     * Open Help menu from profile sidebar
     */
    openProfileHelp(context) {
        context.commit('openProfileHelp')
    },

    /**
     * Close Help menu from profile sidebar
     */
    closeProfileHelp(context) {
        context.commit('closeProfileHelp')
    },
    /**
     * Close all profile pages
     */
    closeAllProfilePages(context) {
        context.commit('closeAllProfilePages')
    },

    /**
     * Redirect from requirements alert
     */
    requirementsAlertRedirect(context) {
        if ($('#chat-dropdown').is(':visible')) {
            $('#chat-dropdown').foundation('close')
        }
        if ($('#notif-dropdown').is(':visible')) {
            $('#notif-dropdown').foundation('close')
        }

        if (context.state.requirementsAlert.type === 'change_settings') {
            window.open('https://' + window.DOMAIN + '/profile/settings', '_system')
        } else if(context.state.requirementsAlert.type === 'location') {
            //no redirect
        } else{
            app.goTo('/profile/pro')
        }

        context.commit('hideRequirementsAlert')
    },
    /**
     * Show requirements alert
     */
    requirementsAlertShow(context, type) {
        context.commit('showRequirementsAlert', type);
    },
    /**
     * Hide requirements alert
     */
    requirementsAlertHide(context) {
        context.commit('hideRequirementsAlert');
    },
    /**
     * Show announce alert
     */
    announceAlertShow(context, data) {
        context.commit('showAnnounceAlert', data);
    },
    /**
     * Hide announce alert
     */
    announceAlertHide(context) {
        context.commit('hideAnnounceAlert');
    },
    /**
     * Redirect to Rush Widget
     */
    goToRush(context, isApp) {
        if (isApp) {
            if (!context.state.userIsPro){
                context.commit('showRequirementsAlert', 'censored');
                return;
            }

            if (context.state.profile.app_view_sensitive_media == 'no') {
                context.commit('showRequirementsAlert', 'change_settings');
                return;
            }
        }

        localStorage.setItem('widgetOpen', true)
        window.location = '/rush'
    },

    confirmDeleteSharingLinks() {
        axios.post('/api/user/delete-all-sharing-links')
    },
}

export default actions
